export const FETCH_SENDER_FAILURE = 'FETCH_SENDER_FAILURE';
export const FETCH_SENDER_REQUEST = 'FETCH_SENDER_REQUEST';
export const FETCH_SENDER_SUCCESS = 'FETCH_SENDER_SUCCESS';
export const SENDER_ENTITY = 'sender';
export const UPDATE_SENDER_EMAIL = 'UPDATE_SENDER_EMAIL';
